export interface EchoNxFormatPipeProps<T = any> {
  method?: 'money' | 'decimal' | 'date' | 'mongoId' | 'contact' | 'localeString' | 'weekday' | 'filesize';
  format?: any;
  transform?: (value: T, entity?: any) => any;
}
